var zhCN = {
  product: {
    SOLD_OUT: '已售罄',
    FINAL_PRICE: '补贴最终价',
    BUY_NOW: '去抢购'
  }
};
export default zhCN;